import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  min?: number;
  max?: number;
  value: number;
  step?: number;
  handleSlide: (value: number) => void;
}
const Slider = ({
  min = 0,
  max = 100,
  value,
  handleSlide,
  step = 1
}: IProps) => {
  return (
    <Body>
      <RangeInput
        min={min}
        max={max}
        value={value}
        id="slider-1"
        onChange={(e) => handleSlide(Number(e.target.value))}
        step={step}
      />
    </Body>
  );
};

export default Slider;

const Body = styled.div`
  width: 100%;
`;

const RangeInput = styled.input.attrs({ type: "range" })<{
  max: number;
  value: number;
}>`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  border-radius: 1rem;
  height: 0.8rem;
  -webkit-transition: 0.2s;
  background: ${(props) => `linear-gradient(
    to right,
    ${Colors.yellow400} ${Number(props?.value / props.max) * 100}%,
    rgba(254, 198, 103, 0.1) ${props.max}%)`};

  transition: all 0.2s ease-in;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 1.2rem;
    height: 1.2rem;
    background: white;
    cursor: pointer;
    border-radius: 50%;
  }

  &::-moz-range-thumb {
    width: 1.2rem;
    height: 1.2rem;
    background: white;
    cursor: pointer;
    border-radius: 50%;
  }

  &::-moz-range-progress {
    background-color: #43e5f7;
  }
`;
